import { Translates } from '@/services/repository/i18n'
import React, { useState, useEffect } from 'react'

export interface SearchInputProps {
  className?: string
  value: string // controlled value from parent
  onDebouncedChange?: (value: string) => void
  onChange?: (value: string) => void // optional immediate handler
  delay?: number
  translates: Translates
  readOnly?: boolean
}

export const SearchInputVanil: React.FC<SearchInputProps> = ({
  value,
  onDebouncedChange,
  onChange,
  delay = 600,
  translates,
  className,
  readOnly = false
}) => {
  useEffect(() => {
    const handler = setTimeout(() => {
      onDebouncedChange?.(value)
    }, delay)

    return () => {
      clearTimeout(handler)
    }
  }, [value, delay, onDebouncedChange])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Immediate "live" update to parent if needed
    onChange?.(e.target.value)
  }

  return (
    <div className={className ? className : 'search-input'}>
      <input
        type='text'
        value={value}
        onChange={handleChange}
        placeholder={translates.for('elements.search.placeholder')}
        readOnly={readOnly}
      />
    </div>
  )
}

export const SearchInput = React.memo(SearchInputVanil)